var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"header p-2"},[_c('div',[_c('span',[_c('i',{staticClass:"fas fa-chevron-down"})]),_c('span',[_vm._v(" Mi sesión ")])]),_c('div',{staticClass:"mx-auto"},[_c('span',[_vm._v("NOMBRE ASESOR")])]),_c('div',[_c('span',[_vm._v("Salir")])])]),_c('div',{staticClass:"spacer-h"}),_c('section',{staticClass:"login__main"})])
}]

export { render, staticRenderFns }